export function normalizeAdminWhatsAppPhone(phone) {
  const digits = String(phone || "").replace(/\D/g, "");
  if (!digits) return null;
  return digits.startsWith("55") ? digits : `55${digits}`;
}

export function buildAdminWhatsAppUrl(phone, message = "") {
  const normalized = normalizeAdminWhatsAppPhone(phone);
  if (!normalized) return null;

  const encodedMessage = encodeURIComponent(message || "");
  const query = encodedMessage ? `?text=${encodedMessage}` : "";
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isMobile = isAndroid || /iPhone|iPad|iPod/i.test(navigator.userAgent);

  if (isAndroid) {
    const fallback = encodeURIComponent(`https://wa.me/${normalized}${query}`);
    const textParam = encodedMessage ? `&text=${encodedMessage}` : "";
    return `intent://send?phone=${normalized}${textParam}#Intent;scheme=whatsapp;package=com.whatsapp.w4b;S.browser_fallback_url=${fallback};end`;
  }

  return isMobile
    ? `https://wa.me/${normalized}${query}`
    : `https://web.whatsapp.com/send?phone=${normalized}${encodedMessage ? `&text=${encodedMessage}` : ""}`;
}

export function openAdminWhatsApp(phone, message = "") {
  const url = buildAdminWhatsAppUrl(phone, message);
  if (!url) return false;

  if (/Android/i.test(navigator.userAgent)) {
    window.location.href = url;
    return true;
  }

  window.open(url, "_blank", "noopener,noreferrer");
  return true;
}
